import type { FmbImage } from '@/consts/frauMeetsBoerse';

interface FmbImageSlotProps {
  image: FmbImage;
  className?: string;
  fit?: 'cover' | 'contain';
}

/**
 * Rendert ein konfiguriertes Bild oder — solange src null ist — einen
 * dezenten Platzhalter mit Beschriftung in denselben Abmessungen.
 */
export default function FmbImageSlot({ image, className, fit = 'cover' }: FmbImageSlotProps) {
  if (image.src !== null) {
    return (
      <img
        src={image.src}
        alt={image.alt}
        className={`${className ?? ''} ${fit === 'contain' ? 'object-contain' : 'object-cover'}`}
      />
    );
  }

  return (
    <div
      className={`${className ?? ''} flex items-center justify-center border border-dashed border-[var(--fmb-border-warm)] bg-[var(--fmb-section-bg)] px-4 text-center text-[13px] text-[var(--fmb-faint)]`}
    >
      {image.placeholderLabel}
    </div>
  );
}
